(() => {
  const initFilter = (filter) => {
    const grid = document.querySelector('[data-centres-grid]');
    if (!grid) return;

    const buttons = filter.querySelectorAll('.centres-alpha-filter__item');
    const cells = Array.from(grid.querySelectorAll('[data-centre-letter]'));
    const randomizeAll = grid.hasAttribute('data-randomize-all');
    const priorityCentre = grid.dataset.priorityCentre;
    const originalOrder = cells.map((cell) => ({
      cell,
      medium: cell.style.getPropertyValue('--medium-order'),
      large: cell.style.getPropertyValue('--large-order'),
    }));

    const restoreOrder = () => {
      originalOrder.forEach(({ cell, medium, large }) => {
        grid.appendChild(cell);
        cell.style.setProperty('--medium-order', medium);
        cell.style.setProperty('--large-order', large);
      });
    };

    const shuffleAll = () => {
      const shuffled = cells.slice();

      for (let i = shuffled.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
      }

      const priorityIndex = shuffled.findIndex(
        (cell) => cell.dataset.centreId === priorityCentre
      );
      const priorityLimit = Math.min(9, shuffled.length);

      if (priorityIndex >= priorityLimit) {
        const targetIndex = Math.floor(Math.random() * priorityLimit);
        [shuffled[priorityIndex], shuffled[targetIndex]] = [
          shuffled[targetIndex],
          shuffled[priorityIndex],
        ];
      }

      shuffled.forEach((cell, index) => {
        grid.appendChild(cell);
        cell.style.setProperty('--medium-order', index);
        cell.style.setProperty('--large-order', index);
      });
    };

    if (randomizeAll) shuffleAll();

    filter.addEventListener('click', (e) => {
      const target = e.target.closest('.centres-alpha-filter__item');
      if (!target || target.hasAttribute('disabled')) return;

      const value = target.dataset.filter;

      buttons.forEach((btn) => btn.classList.remove('is-active'));
      target.classList.add('is-active');

      if (randomizeAll) {
        if (value === 'all') {
          shuffleAll();
        } else {
          restoreOrder();
        }
      }

      cells.forEach((cell) => {
        const show = value === 'all' || cell.dataset.centreLetter === value;
        cell.style.display = show ? '' : 'none';
      });
    });
  };

  const ready = () => {
    document.querySelectorAll('[data-centres-filter]').forEach(initFilter);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})();
